<template>
    <div>
        <div class="d-flex justify-content-end" v-if="checkPermission('slotexpertise_store')">
              <b-button variant="success" @click="createFormShow">{{$t('new') }}</b-button>
        </div>
<!--        <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear" >-->
<!--            <b-row>-->
<!--                <b-col sm="6" md="4" lg="3" xl="6">-->
<!--                    <b-form-group :label="$t('faculty')">-->
<!--                        <faculty-selectbox-->
<!--                            v-model="datatable.queryParams.filter.faculty_code"-->
<!--                        ></faculty-selectbox>-->
<!--                    </b-form-group>-->
<!--                </b-col>-->
<!--            </b-row>-->
<!--        </datatable-filter>-->

        <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>

            <CommonModal ref="storeModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess"
                                 v-if="formProcess=='create'"
                                 :selectedSlotId="selectedSlotId"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="updateModal1" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId"
                                 @updateFormSuccess="updateFormSuccess"
                                 :selectedSlotId="selectedSlotId"
                                 v-if="formProcess=='update'"/>
                </template>
            </CommonModal>
    </div>
</template>
<script>
// Template
// Components
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
// Pages
import CreateForm from "./CreateForm.vue";
import UpdateForm from "./UpdateForm.vue";
// Others
import qs from 'qs'
import SlotExpertiesServices from "../../../../services/SlotExpertiesServices";

export default {
    components: {
        Datatable,
        CommonModal,
        CreateForm,
        UpdateForm,
    },
    props: {
        slotId: {
            type: Number,
        },
    },
    data() {
        return {
            selectedSlotId:null,
            program_code: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('edit'),
                                permission: 'slotexpertise_update',
                                class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                                callback: (row) => {
                                    this.updateFormShow(row.id)
                                }
                            },
                            {
                                text: this.$t('delete'),
                                permission: 'slotexpertise_delete',
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                callback: (row) => {
                                    this.formDelete(row.id)
                                }
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase('concentration'),
                        field: 'program_expertise_name',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('slot_type'),
                        field: 'slot_type_name',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('course_name'),
                        field: 'course_name',
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase('pool_name'),
                        field: 'pool_name',
                        hidden: false,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {
                        slot_id:this.slot_id
                    },
                    sort: 'slot_id',
                    page: 1,
                    limit: 20
                }
            },
            formProcess: null,
            formId: null,
            form: {},
        }
    },
    watch:{
        'slotId':{
            handler(newVal){
                this.selectedSlotId = newVal;
                this.filterSet();
                this.getRows();
            },
            immediate: true
        },
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {
                slot_id:this.slotId
            }
        },
        filterClear() {
            this.filterSet()
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return SlotExpertiesServices.getAll(config)
                                .then((response) => {
                                    this.datatable.rows = response.data.data
                                    this.datatable.total = response.data.pagination.total
                                })
                                .finally(() => {
                                    this.datatable.isLoading = false;
                                });
        },

        // Clear
        formClear() {
            this.formId = null
            this.formProcess = null
        },


        // Create
        createFormShow() {
            this.formId = null
            this.formProcess = 'create'
            this.$refs.storeModal.$refs.commonModal.show()
        },
        createFormSuccess() {
            this.$refs.storeModal.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },

        // Update
        updateFormShow(id) {
            this.formId = id
            this.formProcess = 'update'
            this.$refs.updateModal1.$refs.commonModal.show()
        },
        updateFormSuccess() {
            this.$refs.updateModal1.$refs.commonModal.hide()
            this.getRows()
            this.formClear()
        },
        formDelete(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        SlotExpertiesServices.del(id)
                                     .then(response => {
                                         this.$toast.success(this.$t('api.' + response.data.message));
                                         this.getRows();
                                         this.formClear();
                                     })
                                     .catch(error => {
                                         this.$toast.error(this.$t('api.' + error.data.message));
                                     });
                    }
                })
        },
    }
}
</script>

